import React from 'react';
import omit from 'lodash/omit';
export var ODVerticalSplitLayout = function (props) {
    var constraint = props.constraint, height = props.height, _a = props.children, children = _a === void 0 ? [] : _a, _b = props.flexGrows, flexGrows = _b === void 0 ? [] : _b, style = props.style, _c = props.className, className = _c === void 0 ? [] : _c;
    var styleTop = omit({
        height: constraint === 'top' && height !== undefined ? height : undefined,
        flexGrow: flexGrows[0],
    });
    var styleBottom = omit({
        height: constraint === 'bottom' && height !== undefined ? height : undefined,
        flexGrow: flexGrows[1],
    });
    // @ts-ignore
    var firstChild = children[0] || 'Provide [0] children';
    // @ts-ignore
    var secondChild = children[1] || 'Provide [1] children';
    return (React.createElement("div", { className: "h-full flex flex-col", style: style },
        React.createElement("div", { style: styleTop, className: className[0] }, firstChild),
        React.createElement("div", { style: styleBottom, className: className[1] }, secondChild)));
};
//# sourceMappingURL=ODVerticalSplitLayout.js.map